const live = (state) => state.live;
const clients = (state) => live(state).clients;

export const online = (state, id) => !!clients(state)[id];
